const transportCosts = [
    //                          Gävle       Sandviken       Bollnäs     Söderhamn       Hudiksvall      Ljusdal     Sundsvall       Timrå       Östhammar       Norrtälje
    /* Gävle        */     [    null,       995,            995,        995,            1495,           1495,       1495,           1495,       1495,           1495        ],
    /* Sandviken    */     [    995,        null,           995,        995,            1495,           1495,       1495,           1495,       1495,           1495        ],
    /* Bollnäs      */     [    995,        995,            null,       995,            995,            995,        1495,           1495,       1995,           1995        ],
    /* Söderhamn    */     [    995,        995,            995,        null,           995,            995,        1495,           1495,       1995,           1995        ],
    /* Hudiksvall   */     [    1495,       995,            995,        995,            null,           995,        1495,           1495,       1995,           1995        ],
    /* Ljusdal      */     [    1495,       995,            995,        995,            995,            null,       1495,           1495,       1995,           1995        ],
    /* Sundsvall    */     [    1495,       995,            995,        995,            995,            1495,       null,           995,        1995,           1995        ],
    /* Timrå        */     [    1495,       995,            995,        995,            995,            1495,       995,            null,       1995,           1995        ],
    /* Östhammar    */     [    1495,       1995,           1995,       1995,           1995,           1995,       1995,           1995,       null,           995         ],
    /* Norrtälje    */     [    1495,       1995,           1995,       1995,           1995,           1995,       1995,           1995,       995,            null        ],

]

const transportIndex = [ 'Gävle', 'Sandviken', 'Bollnäs', 'Söderhamn', 'Hudiksvall', 'Ljusdal', 'Sundsvall', 'Timrå', 'Östhammar', 'Norrtälje' ]

const getTransportCost = ( from, to) => {
    if (from === to) return 0;

    const fromIndex = transportIndex.indexOf(from);
    const toIndex = transportIndex.indexOf(to);

    if( fromIndex === -1 || toIndex === -1 ) {
        console.error({msg:'transportIndex not found', from, to, transportIndex})
        return 0
    }

    return transportCosts[fromIndex][toIndex]

}

export {
    getTransportCost,
    transportIndex
};